import * as z from "zod/v4/mini";
const issueSchema = z.looseObject({
    code: z.string(),
    field: z.string(),
    message: z.string(),
});
const errorSchema = z.looseObject({
    error: z.looseObject({
        code: z.string(),
        message: z.string(),
        issues: z._default(z.array(issueSchema), []),
        details: z.optional(z.record(z.string(), z.unknown())),
    }),
});
const fallbackSchema = z.looseObject({
    message: z.string().check(z.minLength(1)),
    logId: z.optional(z.string()),
    systemLogId: z.optional(z.string()),
});
export const coreHttpParsers = {
    payload(value) {
        const parsed = errorSchema.safeParse(value);
        return parsed.success ? parsed.data.error : undefined;
    },
    fallback(value) {
        const parsed = fallbackSchema.safeParse(value);
        return parsed.success ? parsed.data : undefined;
    },
};
//# sourceMappingURL=core-http-protocol.js.map